<template>
  <div class="device-list-wrapper">
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="20">
                <el-form-item label="设备名称：" prop="hostname" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.hostname" style="width:175px" />
                </el-form-item>
                <el-form-item label="提供商：" prop="provider" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.provider" style="width:175px" />
                </el-form-item>
                <el-form-item label="可用区:" prop="az_name" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.az_name" style="width:175px" />
                </el-form-item>
                <el-form-item label="设备类型:" prop="dev_type" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.dev_type" placeholder="请选择设备" style="width: 175px">
                    <el-option label="全部设备" value=""></el-option>
                    <el-option label="服务器" :value="0"></el-option>
                    <el-option label="虚拟机" :value="1"></el-option>
                    <el-option label="容器" :value="2"></el-option>
                    <el-option label="交换机" :value="3"></el-option>
                    <el-option label="防火墙" :value="4"></el-option>
                    <el-option label="路由器" :value="5"></el-option>
                    <el-option label="动环系统" :value="6"></el-option>
                    <el-option label="录像机或摄像头" :value="7"></el-option>
                    <el-option label="传感器" :value="8"></el-option>
                    <el-option label="其他" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="规格描述：" prop="spec_desc" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.spec_desc" style="width:175px" />
                </el-form-item>
                <el-form-item label="状态:" prop="status" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.status" placeholder="请选择有效状态" style="width: 175px">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="有效" value="0"></el-option>
                    <el-option label="无效" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="占用状态:" prop="active_state" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.active_state" placeholder="请选择占用状态" style="width: 175px">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="空闲" value="0"></el-option>
                    <el-option label="占用" value="1"></el-option>
                    <el-option label="维护中" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="运行状态:" prop="running_state" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.running_state" placeholder="请选择运行状态" style="width: 175px">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="在线" value="0"></el-option>
                    <el-option label="离线" value="1"></el-option>
                  </el-select>
                </el-form-item> -->
              </el-col>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
              <el-col :span="24">
                <div class="action-buttons-row">
                  <!-- 新增按钮 - 隐藏 -->
                  <el-button type="success" icon="el-icon-plus" size="small" plain
                    v-show="false"
                    @click="handleCreate">
                    新增
                  </el-button>
                  <el-button type="primary" icon="el-icon-upload" size="small" plain
                    @click="handleImport">
                    导入
                  </el-button>
                  <el-button type="primary" icon="el-icon-download" size="small" plain
                    @click="handleExport">
                    导出
                  </el-button>
                  <el-button type="primary" icon="el-icon-document" size="small" plain
                    @click="handleDownloadTemplate">
                    下载模板
                  </el-button>
                </div>
              </el-col>

            </el-row>
          </el-form>
        </el-card>
      </el-row>

      <div class="main-table">
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%;"
            height="100%"
            :fit="true"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
          <el-table-column header-align="center" align="center" show-overflow-tooltip width="140" label="操作">
          <template v-slot="scope">
            <el-button
              type="text"
              size="mini"
              @click="showDetails(scope.row)">详情</el-button>
              <el-button
              type="text"
              size="mini"
              @click="editdDevices(scope.row)">编辑</el-button>
              <el-button
              type="text"
              size="mini"
              @click="delRegion(scope.row)">删除</el-button>
          </template>
        </el-table-column>
            <!-- 设备名称 -->
            <el-table-column prop="hostname" label="设备名称" width="110" />
            <el-table-column  prop="host_ip" label="主机IP" width="110" />
            <el-table-column  prop="ipmi_addr" label="IPMI地址" width="110" />
            <el-table-column  prop="ipmi_user" label="IPMI用户" width="100" />
            <el-table-column label="设备类型" width="90">
              <template v-slot="scope">
                {{ formatDevType(scope.row.dev_type) }}
              </template>
            </el-table-column>
            <el-table-column  prop="dev_character" label="资源类型" width="100" />
            <el-table-column prop="spec_desc" label="规格描述" min-width="280" />
            <!-- 提供商 -->
            <el-table-column prop="provider" label="提供商" min-width="120" />
              <!-- 可用区 -->
            <el-table-column prop="az_name" label="可用区" width="120" />
            <!-- 状态列 -->
            <el-table-column prop="status" label="状态" width="90">
              <template v-slot="scope">
                 <el-tag :type="getformatStatus(scope.row.status)">
                  {{ formatStatus(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 占用状态列 -->
            <el-table-column prop="active_state" label="占用状态" width="90">
              <template v-slot="scope">
                 <el-tag :type="getactiveState(scope.row.active_state)">
                  {{ activeState(scope.row.active_state) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 运行状态列 -->
            <el-table-column prop="running_state" label="运行状态" width="90">
              <template v-slot="scope">
                 <el-tag :type="getrunningStatus(scope.row.running_state)">
                  {{ runningStatus(scope.row.running_state) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 资源可用期限（时间段） -->
            <el-table-column label="资源可用期限" width="200">
              <template v-slot="scope">
                <div v-if="scope.row.start_time || scope.row.end_time">
                  {{ (scope.row.start_time || '').split(' ')[0] || '–' }}
                  至
                  {{ (scope.row.end_time || '').split(' ')[0] || '–' }}
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrapper">
        <el-row type="flex" justify="left">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pagination.page"
              :page-sizes="pagination.pageSizeList"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
          </el-pagination>
        </el-row>
      </div>
    </el-row>
    <!-- 引入 CreateDevices 组件 -->
    <create-devices ref="createDevices" @success="getTableData"></create-devices>
     <!-- 编辑组件 -->
    <edit-devices ref="editDevices" @success="getTableData"></edit-devices>
  </div>
</template>
<script>
import CreateDevices from './CreateNonManagedDevices.vue';
import EditDevices from './EditNonManagedDevices.vue';
import topLine from "@/components/save-common/topLine.vue";
import util from '@/libs/util.js'
import { MessageBox } from 'element-ui';

export default {
  name: "non-managed-devices",
  components: {
    topLine,
    CreateDevices,
    EditDevices,
  },
  mounted () {
  },
  data() {
    return {
      pageTitle: "非纳管设备列表",
      labelWidth: '120px',
      baseApi: '/api-30216/api/devices',
      tableDataApi: '/api-30216/api/devices',
      searchForm: {
        hostname: '',
        provider: '',
        az_name: '',
        dev_type:'',
        spec_desc:'',
        active_state:'',
        running_state:'',
        status:'',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
        pageSizeList: [10, 20, 50, 100]
      },
      tableData: [],
    }
  },
  created() {
    const provider = this.$route.query.provider;
    const azName = this.$route.query.name;

    if (provider || azName) {
      this.searchForm.provider = provider || '';
      this.searchForm.az_name = azName || '';

      if (this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if (this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
    }
    this.getTableData();
  },
  methods: {
    formatDevType(value) {
      const map = {
        0: '服务器',
        1: '虚拟机',
        2: '容器',
        3: '交换机',
        4: '防火墙',
        5: '路由器',
        6: '动环系统',
        7: '录像机或摄像头',
        8: '传感器',
        '-1': '其他',
        '': '未知',
        undefined: '未知'
      };
      return map[value] || '未知';
    },
    formatStatus(value) {
      const map = {
        0: '有效',
        1: '无效',
      };
      return map[value] || '-';
    },
    getformatStatus(value) {
      switch (value) {
        case 0:
          return 'success';
        case 1:
          return 'danger';
        default:
          return 'info';
      }
    },
    activeState(value) {
      const map = {
        0: '空闲',
        1: '占用',
        2: '维护中'
      };
      return map[value] || '-';
    },

    getactiveState(value) {
      switch (value) {
        case 0:
          return 'success';
        case 1:
          return ;
        case 2:
          return 'warning';
        default:
          return 'info';
      }
    },
    runningStatus(value) {
      const map = {
        0: '在线',
        1: '离线',
      };
      return map[value] || '-';
    },
    getrunningStatus(value) {
      switch (value) {
        case 0:
          return 'success';
        case 1:
          return 'danger';
        case 2:
          return 'warning';
        default:
          return 'info';
      }
    },

    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },

    handleReset() {
      this.searchForm = {
        hostname: '',
        provider: '',
        az_name: '',
        dev_type:'',
        spec_desc:'',
        active_state:'',
        running_state:'',
        status:'',
        page: 1,
        pageSize: 10,
      };
      this.getTableData();
    },
    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    showDetails(row) {
      this.$router.push({
        path: '/showDetails',
        query: {
          dev_id: row.dev_id,
          page: this.pagination.page,       
          pageSize: this.pagination.pageSize, 
        }
      })
    },
    handleCreate() {
      this.$refs.createDevices.openDialog();
    },

    editdDevices(row) {
      this.$refs.editDevices.openDialog(row);
    },
    getTableData() {
      this.$axios.get(this.tableDataApi, {
      params: {
        hostname: this.searchForm.hostname,
        provider: this.searchForm.provider,
        az_name: this.searchForm.az_name,
        dev_type:this.searchForm.dev_type,
        spec_desc:this.searchForm.spec_desc,
        active_state:this.searchForm.active_state,
        running_state:this.searchForm.running_state,
        status:this.searchForm.status,
        ext_05: 1,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
      }
      }).then(response => {
        this.tableData = response.data || [];
        this.pagination.total = response.total || 0;
      });
    },

    delRegion(row) {
      MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$axios.delete(`/api-30216/api/devices/${row.dev_id}`).then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '删除成功');
          } else {
            this.$message.error(response.message || '删除失败');
          }
          this.getTableData();
        }).catch(error => {
          console.error(error);
          this.$message.error('删除失败，请检查网络或服务状态');
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    async handleExport() {
      const { hostname, provider, az_name, dev_type, active_state, running_state, status } = this.searchForm;
      const params = new URLSearchParams();

      if (hostname) params.append('hostname', hostname);
      if (provider) params.append('provider', provider);
      if (az_name) params.append('az_name', az_name);
      if (dev_type !== '') params.append('dev_type', dev_type);
      if (active_state !== '') params.append('active_state', active_state);
      if (running_state !== '') params.append('running_state', running_state);
      if (status !== '') params.append('status', status);
      params.append('ext_05', 1);
      params.append('ext_05', '');

      const url = `${this.baseApi}/export?${params.toString()}`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${util.cookies.get('token')}`
          }
        });

        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || '导出失败');
        }

        if (!response.ok) throw new Error(`网络错误: ${response.status}`);

        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'devices_export.xlsx';

        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
          if (utf8Match) {
            try {
              filename = decodeURIComponent(utf8Match[1]);
            } catch (e) {}
          } else {
            const match = contentDisposition.match(/filename="?([^"]+)"?/i);
            if (match) filename = match[1];
          }
        }

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败', error);
        this.$message.error(error.message || '导出失败，请检查网络或联系管理员');
      }
    },


    async handleImport() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx,.xls,.csv';
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
          const response = await fetch(`${this.baseApi}/import`, {
            method: 'POST',
            body: formData,
            headers: {
              'Authorization': `Bearer ${util.cookies.get('token')}`
            }
          });

          const contentType = response.headers.get('Content-Type');
          let result;
          if (contentType && contentType.includes('application/json')) {
            result = await response.json();
          } else {
            const text = await response.text();
            try {
              result = JSON.parse(text);
            } catch {
              result = { error: '上传失败：非预期响应格式', detail: text };
            }
          }

          if (response.ok && result.code === 200) {
            this.$message.success(result.message || '导入成功');
            this.getTableData();
          } else {
            this.$message.error(result.error || result.message || '导入失败');
          }
        } catch (error) {
          console.error('导入异常', error);
          this.$message.error('网络错误，导入失败');
        }
      };
      input.click();

      input.value = '';
    },

   async handleDownloadTemplate() {
      const url = `${this.baseApi}/template`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${util.cookies.get('token')}`
          }
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const blob = await response.blob();
        const disposition = response.headers.get('Content-Disposition');
        let filename = 'devices_import_template.xlsx';

        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/i);
          if (utf8Match) {
            try {
              filename = decodeURIComponent(utf8Match[1]);
            } catch (e) {}
          } else {
            const match = disposition.match(/filename="?([^"]+)"?/i);
            if (match) filename = match[1];
          }
        }

        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);

        this.$message.success('模板下载成功');
      } catch (error) {
        console.error('下载模板失败', error);
        this.$message.error('下载模板失败，请重试或联系管理员');
      }
    },

  }

}
</script>

<style scoped lang="scss">
.device-list-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pagebody {
  display: flex;
  flex-direction: column;
  margin-top: 0;
  margin-left: 0;
  flex: 1;
  min-height: 0;
}

.filter-bar {
  margin-bottom: 10px;
}

.main-table {
  margin-top: 10px;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: auto;
}

.main-table ::v-deep .el-table {
  width: 100%;
}

.pagination-wrapper {
  margin-top: 10px;
  margin-bottom: 18px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}

.batch-button {
  min-width: 95px;
}

.action-buttons-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.action-buttons-row .el-button {
  margin-left: 0 !important;
}
</style>